import { render } from "./canceled-visits.vue?vue&type=template&id=73e8269b&ts=true"
import script from "./canceled-visits.vue?vue&type=script&lang=ts"
export * from "./canceled-visits.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__